import a from "react";
import { getIconColor as i } from "./iconfont.es5470.js";
import g from "./iconfont.es5471.js";
const m = {
  display: "block"
}, h = ({ size: t = 16, useVw: c, useRem: e, color: o, withColor: l, removeClassName: n, disableSSR: d, style: r, ...p }) => {
  const x = r ? { ...m, ...r } : m;
  return /* @__PURE__ */ a.createElement(g, { disableSSR: d }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-bangzhuzhongxin", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: c ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (e ? "rem" : "px"), height: c ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (e ? "rem" : "px"), className: n ? "" : "iconpark-icon", style: x, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: n ? "" : "32px-å¸®å©ä¸­å¿"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: n ? "" : "normal",
        fill: l ? i(o, 0, "#262933") : "#262933",
        datafollowfill: l ? i(o, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M15.996 4.9c-6.13 0-11.1 4.97-11.1 11.1s4.97 11.1 11.1 11.1c2.124 0 4.106-.595 5.79-1.628a.9.9 0 1 1 .941 1.535 12.844 12.844 0 0 1-6.73 1.893c-7.125 0-12.9-5.775-12.9-12.9 0-7.124 5.775-12.9 12.9-12.9 7.124 0 12.9 5.776 12.9 12.9a12.862 12.862 0 0 1-1.894 6.731.9.9 0 1 1-1.535-.94A11.061 11.061 0 0 0 27.096 16c0-6.131-4.97-11.1-11.1-11.1Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M15.433 20.581a1.263 1.263 0 1 1 1.786 1.786 1.263 1.263 0 0 1-1.786-1.786Zm-1.993-9.734c.75-.66 1.767-1.03 2.828-1.03 1.06 0 2.077.37 2.826 1.03.75.66 1.171 1.555 1.171 2.488 0 1.385-.497 2.113-1.773 3.236l-.196.177c-.742.674-.938 1.014-.938 1.704a.905.905 0 0 1-.32.679 1.17 1.17 0 0 1-.77.28 1.17 1.17 0 0 1-.771-.28.905.905 0 0 1-.32-.679c0-1.385.497-2.113 1.774-3.237l.196-.176c.742-.674.938-1.015.938-1.704a1.51 1.51 0 0 0-.533-1.131 1.95 1.95 0 0 0-1.284-.468 1.95 1.95 0 0 0-1.285.468c-.341.3-.533.707-.533 1.13l-.01.131a.938.938 0 0 1-.392.614c-.214.153-.487.23-.762.213a1.155 1.155 0 0 1-.723-.303.9.9 0 0 1-.293-.654c0-.933.42-1.828 1.17-2.488Z"
        }
      )
    )
  )));
}, k = h;
export {
  k as default
};
